

























































































































import Subheader from '@/components/Subheader.vue'
import TemplateListItem from './TemplateListItem.vue'
import SplitView from '@/components/SplitView.vue'
import TemplateManager, { Location } from '@/components/Templates/TemplateManager.vue'
import * as graph from '@shared/types/graphql'
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import store from '@/store'
import $ from 'jquery'
import { Button } from '@alpha/ink'
import LoadingIndicator from '@/components/LoadingIndicator.vue'
import * as db from '@shared/types/database'
import { defaultFieldValue } from '@/utilities/template-helpers'
import A from '@/utilities/alpha'
import { DEFAULT_TEMPLATE, SelectedTemplate } from '@/types/frontend'

@Component({
  components: {
    Subheader,
    TemplateListItem,
    SplitView,
    TemplateManager,
    LoadingIndicator,
    Button
  }
})
export default class TemplateBuilder extends Vue {
  @Prop({ required: true }) readonly title!: string
  @Prop({ required: true }) location!: Location
  @Prop({ required: true }) initialTemplate!: SelectedTemplate

  @Ref('templateListItems') readonly templateListItemsComponents!: TemplateListItem[] | null
  @Ref('templateManager') readonly templateManagerComponent!: TemplateManager

  newTemplateId: number | null = null
  selectedTemplate: SelectedTemplate = DEFAULT_TEMPLATE
  templateValuesAltered: boolean = false

  addAssetToTest = store.dispatch.testCreation.addPrototype
  removeAssetFromTest = store.dispatch.testCreation.removePrototype

  get acl () {
    return store.state.testCreation.acl
  }

  get sharedAssets () {
    return store.state.testCreation.projectPrototypes
  }

  get templates () {
    return store.state.testCreation.accountTemplates
  }

  get testPrototypes () {
    return store.state.testCreation.prototypes
  }

  get featuredTestTemplates () {
    return this.templates.filter(template => {
      return template.created_by === 'System' && template.featured
    })
  }

  get customTestTemplates () {
    return this.templates.filter(template => {
      return template.created_by !== 'System' && template.featured
    })
  }

  get assets () {
    return Object.assign({}, this.testPrototypes, this.sharedAssets)
  }

  mounted () {
    this.selectedTemplate = A.clone(this.initialTemplate)
    this.scrollToSelectedTemplate()
  }

  submit () {
    return this.templateManagerComponent.validate()
  }

  didSubmit (test: Pick<graph.Test, 'id'>, projectId?: string | null) {
    return this.templateManagerComponent.didSubmit(test, projectId)
  }

  showSwitchConfirmation (templateId: number) {
    return this.newTemplateId !== null && this.newTemplateId === templateId
  }

  get isTemplateSelected () {
    return this.selectedTemplate?.template.id !== -1
  }

  updateValuesAltered (val: boolean) {
    this.templateValuesAltered = val
  }

  async checkIfShouldPromptForSwitch (templateId: number) {
    this.scrollToSelectedTemplate(templateId)

    const newTemplateSelected = this.selectedTemplate?.template.id !== templateId
    if (newTemplateSelected && this.templateValuesAltered) {
      // Setting this to a value causes the switch prompt to show up.
      this.newTemplateId = templateId
    } else {
      await this.setTemplate(templateId)
    }
  }

  async setTemplate (templateId: number) {
    this.newTemplateId = null
    this.scrollToTopOfView()
    const template = this.templates.find(template => template.id === templateId)
    const templateValues = Object.keys(template!.template_fields).reduce((acc: Record<string, db.TemplateValue>, key: string) => {
      const value = template!.template_fields[key].value ?? defaultFieldValue(template!.template_fields[key])
      acc[key] = { value }
      return acc
    }, {})
    this.selectedTemplate = { template: template!, templateValues }
  }

  scrollToSelectedTemplate (id?: number) {
    if (!this.templateListItemsComponents) return

    const selectedListItem = this.templateListItemsComponents
      .find(item => {
        if (id !== undefined) {
          return item.id === id
        } else {
          return item.selected
        }
      })
    if (!selectedListItem) return
    const selectedEl = selectedListItem.$el as HTMLElement
    if (!selectedEl.parentNode) return
    const scrollContainer = selectedEl.parentNode.parentNode
    if (!scrollContainer) return
    const offsetTop = selectedEl.offsetTop
    $(scrollContainer).animate({ scrollTop: offsetTop })
  }

  scrollToTopOfView () {
    const splitViewPanel = (this.$refs.splitView as Vue).$refs.scrollArea
    $(splitViewPanel).animate({ scrollTop: 0 })
  }
}
